export default Object.freeze({
  STATUS_SUCCESS: 200,
  STATUS_PARAM_ERROR: 400,
  STATUS_ACCOUNT_LOCKED: 401,
  STATUS_ACCOUNT_DELETE_RESTRICTED: 403,
  STATUS_NOT_FOUND: 404,
  STATUS_ACCOUNT_DUPLICATED: 409,
  STATUS_CONTACT_CONSTRAINT_VIOLATION: 410,
  STATUS_SYSTEM_ERROR: 500,
  STATUS_WARNING: 600,
  STATUS_REG_MISMATCH_PASSCODE: 400,
  STATUS_REG_REGISTERED_BILLINGID: 401,
  STATUS_REG_UNEXPECTED_DOMAIN: 402,
  STATUS_REG_REGISTERED_ADDRESS: 403,

  PATH_LOGIN: '/login',
  PATH_LOGOUT: '/logout',
  PATH_SESSION: '/sessions',
  PATH_BILLING: '/billings',
  PATH_BILLING_INVOICE_MONTH_LIST: '/billings/invoicemonth/list',
  PATH_BILLING_UPDATE: '/billing',
  PATH_BILLING_ADDRESS: '/billing/address',
  PATH_BILLING_ADDRESS_UPDATE: '/billing/address/update',
  PATH_EXPIRE: '/expire',
  PATH_GROUP: '/billinggroups',
  PATH_OPENING: '/openinguides',
  PATH_USERID_REISSUE: '/account/userid/reissue',
  PATH_PASSWORD_REISSUE: '/account/password/reissue',
  PATH_PASSWORD: '/account/password',
  PATH_PASSWORD_RESET: '/account/password/reset',
  PATH_ACCOUNT_HASH: '/account/hash',
  PATH_ACCOUNT_USER_LIST: '/accounts',
  PATH_ACCOUNT_CREATE_USER: '/account/create',
  PATH_ACCOUNT_UPDATE_USER: '/account/update',
  PATH_ACCOUNT_DELETE_USER: '/account/delete',
  PATH_ACCOUNT_CREATE_FORM: '/account/createform',
  PATH_PROFILE: '/profile',
  PATH_INVOICE: '/invoice',
  PATH_MANUAL: '/manual',
});
